'use strict';
(function (document, navigator, standalone) {
  // prevents links from apps from oppening in mobile safari
  // this javascript must be the first script in your <head>
  if (standalone in navigator && navigator[standalone]) {
    let curnode,
      location = document.location,
      stop = /^(a|html)$/i;
    document.addEventListener(
      'click',
      e => {
        curnode = e.target;
        while (!stop.test(curnode.nodeName)) {
          curnode = curnode.parentNode;
        }
        // Condidions to do this only on links to your own app
        // if you want all links, use if('href' in curnode) instead.
        if (
          'href' in curnode &&
          (curnode.href.indexOf('http') || ~curnode.href.indexOf(location.host))
        ) {
          e.preventDefault();
          location.href = curnode.href;
        }
      },
      false,
    );
  }
})(document, window.navigator, 'standalone');

function initMap() {
  const myLatLng = { lat: -22.9826917, lng: -43.3641901 };
  const map = new google.maps.Map(document.getElementById('map'), {
    zoom: 17,
    center: myLatLng,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
  });
  const marker = new google.maps.Marker({
    position: myLatLng,
    map: map,
    title: 'Shopping Via Parque',
  });
}

function getParameterGlobal(theParameter) {
  const params = window.location.search.substr(1).split('&');

  for (let indexParam = 0; indexParam < params.length; indexParam++) {
    const param = params[indexParam].split('=');

    if (param[0].toUpperCase() == theParameter.toUpperCase()) {
      return decodeURIComponent(param[1]);
    }
  }

  return '';
}

$(document).ready(() => {
  //background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 21.1.0  SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Camada_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 15 8.8' style='enable-background:new 0 0 15 8.8%3B' xml:space='preserve'%3E%3Cg%3E%3Cg%3E%3Cpath fill='#{$arrowColor}' d='M8.1 8.6l6.7-6.7C14.9 1.7 15 1.5 15 1.3c0-0.2-0.1-0.4-0.2-0.6l-0.5-0.5c-0.3-0.3-0.8-0.3-1.2 0L7.5 5.9L1.9 0.2C1.7 0.1 1.5 0 1.3 0C1.1 0 0.9 0.1 0.7 0.2L0.2 0.7C0.1 0.9 0 1.1 0 1.3c0 0.2 0.1 0.4 0.2 0.6l6.7 6.7c0.2 0.2 0.4 0.2 0.6 0.2C7.7 8.8 7.9 8.7 8.1 8.6L8.1 8.6z M8.1 8.6'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  const bodyStyles = window.getComputedStyle(document.body);
  let arrowColor = bodyStyles.getPropertyValue('--main-color');

  arrowColor = arrowColor.replace('#', '%23');
  arrowColor = arrowColor.replace(' ', '');

  $('.input__holder--select select').css(
    'background-image',
    `url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 21.1.0  SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Camada_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 15 8.8' style='enable-background:new 0 0 15 8.8%3B' xml:space='preserve'%3E%3Cg%3E%3Cg%3E%3Cpath fill='${arrowColor}' d='M8.1 8.6l6.7-6.7C14.9 1.7 15 1.5 15 1.3c0-0.2-0.1-0.4-0.2-0.6l-0.5-0.5c-0.3-0.3-0.8-0.3-1.2 0L7.5 5.9L1.9 0.2C1.7 0.1 1.5 0 1.3 0C1.1 0 0.9 0.1 0.7 0.2L0.2 0.7C0.1 0.9 0 1.1 0 1.3c0 0.2 0.1 0.4 0.2 0.6l6.7 6.7c0.2 0.2 0.4 0.2 0.6 0.2C7.7 8.8 7.9 8.7 8.1 8.6L8.1 8.6z M8.1 8.6'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
  );

  const iosWebAppCTA = function () {
    const isHome = typeof isHomeAliansce !== 'undefined';

    let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
      webApp = window.navigator.standalone,
      showPop = true;

    if (iOS && showPop && !webApp && isHome) {
      $('body').append(
        "<div class='iphone-pop'>Adicione o app <span class='iphone-pop__shopping'>" +
          document.title +
          "</span> no seu celular clicando no ícone <span class='iphone-pop__icon'>compartilhar</span> e, em seguida, 'Tela de Início'.<a href='' class='iphone-pop__close'>Fechar</a></div>",
      );

      $('.iphone-pop__close').on('click', e => {
        e.preventDefault();
        $('.iphone-pop').hide();
        showPop = false;
      });
    }
  };

  iosWebAppCTA();

  // User login menu
  (function () {
    const $trigger = $('.user-menu__trigger--logged');

    $trigger.on('click', function (e) {
      e.preventDefault();
      $('.tools__search').removeClass('open');
      $(this).toggleClass('user-menu--show');
      if ($('.user-menu').hasClass('is--open')) {
        $('.user-menu').removeClass('is--open');
      } else {
        $('.user-menu').addClass('is--open');
      }
    });

    $('.user-menu__clear').on('click', () => {
      $trigger.removeClass('user-menu--show');
    });
  })();

  // popups
  (function () {
    if ($('.button--popup').length > 0) {
      $('.button--popup').magnificPopup({
        type: 'inline',
        callbacks: {
          beforeOpen: function () {
            jQuery('body').css('overflow', 'hidden');
          },
          beforeClose: function () {
            jQuery('body').css('overflow', 'auto');
          },
        },
      });
    }
  })();
  // anchor
  (function () {
    $('.link--anchor').on('click', function (e) {
      e.preventDefault();
      const href = $(this).attr('href');
      if ($('body').is('.menu-opened')) {
        $('body').removeClass('menu-opened');
      }
      $('html, body').animate(
        {
          scrollTop: $(href).offset().top,
        },
        2000,
      );
    });
  })();
  // dirt inputs
  $('.input-holder__field').each(function () {
    const $this = $(this);
    if ($this.val().length != 0) {
      $this.addClass('dirt-input');
    }
    $this.focus(() => {
      $this.addClass('dirt-input');
    });
    $this.blur(function () {
      if (this.id == 'contactPhone') {
        $this.val($this.val().replace(/\D/g, ''));
      }

      if ($this.val().length != 0) {
        $this.addClass('dirt-input');
      } else {
        $this.removeClass('dirt-input');
      }
    });
  });

  // categorização de lojas
  (function () {
    function createCategoryArray(data) {
      const array = data.split('}}{{');
      array[0] = array[0].substr(2);
      array[array.length - 1] = array[array.length - 1].substr(
        0,
        array[array.length - 1].length - 2,
      );
      return array;
    }

    $('.accordion__group .store-search__input').on('change', function (e) {
      const inputValue = $(this).val();
      if (inputValue === '') {
        $(this).parents('.accordion__group').find('.store-list li').show();
      } else {
        $(this).parents('.accordion__group').find('.accordion__input').prop('checked', true);
        $(this)
          .parents('.accordion__group')
          .find('.store-list li')
          .each(function () {
            const $storeitem = $(this);
            const storeCategoryArray = createCategoryArray($storeitem.data('category'));
            if (storeCategoryArray.indexOf(inputValue) > -1) {
              $storeitem.show();
            } else {
              $storeitem.hide();
            }
          });
      }
    });
    $('.accordion__input').on('change', function (e) {
      if ($(this).attr('checked', false)) {
        $(this).parents('.accordion__group').find('.store-list li').show();
      }
    });
  })();

  // Ajuste dos accordions para iphone
  (function () {
    $('.accordion__label').on('click', function (e) {
      const $this = $(this);
      if ($(e.target).hasClass('store-search__input')) {
        return false;
      }
    });
  })();
  (function () {
    $('.lum-aggregate-document-count').each(function () {
      let documentCount = $(this).text();
      documentCount = documentCount.substr(1);
      documentCount = documentCount.substr(documentCount - 1, 1);
      $(this).text(documentCount);
    });
  })();

  // Placeholder select
  (function () {
    const $select = $('select');
    $select.on('change', () => {
      if ($('select option:selected').index() == 0) {
        $select.css('color', '#838383');
      } else {
        $select.css('color', '#454545');
      }
    });
  })();

  // Banner Viewport Adjustment
  (function () {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  })();

  // Toggle Small Accordion
  const toggleSmallAccordion = function (parent, header) {
    const $parent = $(parent);

    $parent.each(function () {
      const $this = $(this),
        $itemHeader = $this.find(header);

      $itemHeader.on('click', e => {
        const $target = $(e.target);
        if ($target.is('[class*="card-group__header"]')) {
          $parent.not($this).removeClass('is--shown');
          $parent.removeClass('card-group--editing');
          $this.toggleClass('is--shown');
        }
      });
    });
  };

  toggleSmallAccordion('.accordion-small', '.accordion-small__header');

  //
  // Highlight
  if ($(window).width() >= 740 && $('.highlight__title').length > 0) {
    let controlHighLightHeight = $($('.highlight__title')[0]).height().toFixed(1) || 0;
    const maxHeight = parseFloat($('.highlight__title').css('max-height'));

    $('.highlight__title').each(function () {
      const $this = $(this);
      if ($this.height() >= maxHeight) {
        controlHighLightHeight = $this.height().toFixed(1);
      }

      if (controlHighLightHeight >= maxHeight) {
        $('.highlight__title').css('min-height', maxHeight);
      }
    });
  }
  //
  // Dirty inputs
  $('.parking__cpf input').each(function () {
    const $this = $(this);
    $this.focus(() => {
      $this.addClass('dirt-input');
    });
    $this.blur(() => {
      if ($this.val().length != 0) {
        $this.addClass('dirt-input');
      } else {
        $this.removeClass('dirt-input');
      }
    });
  });
});
